import React, { Component, Fragment } from 'react';

// 기타 react
import { connect } from "react-redux";
import compose from "recompose/compose";
import {
    reduxForm, 
    getFormValues,
    getFormSubmitErrors,
    SubmissionError
} from 'redux-form';
import { FormattedMessage } from "react-intl";
import isEmpty from 'lodash-es/isEmpty';
import ReactJson from 'react-json-view';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from '@material-ui/core/CircularProgress';
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

// custom
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import FormField from "components/common/input/FormField";
import CustomSelect from "components/common/input/CustomSelect";
import Button from "components/react-template/CustomButtons/Button.jsx";
import ButtonFileUploaderComponent from "components/uploader/ButtonFileUploaderComponent";
import GridContainer from "components/react-template/Grid/GridContainer.jsx";
import GridItem from "components/react-template/Grid/GridItem.jsx";
import { BACKEND_API_URL } from 'util/constants';
import { download } from 'util/common';
import { getFormInitValues } from 'util/form';
import {
    DEFAULT_VALUES_FOR_IMAGE_DEIDENTIFICATION,
    IMAGE_FEATURE_TYPES,
    IMAGE_LANGUAGES
} from 'util/document';
import { FETCH_API } from 'store/sagas/fetch';
import { 
    crudCreateForMultipart as crudCreateForMultipartAction
} from "store/actions/dataActions";
import { 
    showNotification as showNotificationAction
} from 'store/actions/notificationActions';


class ImageFileDeIdentification extends Component {
    constructor(props) {
        super(props);
        this.state = {
          fileNames: [],
          files: [],
          isProcessing: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.refreshVersion !== this.props.refreshVersion ) {
            if( this.props.anyTouched || this.props.dirty ) {
                this.props.reset();
                this.setState({
                    fileNames: [],
                    files: [],
                    isProcessing: false
                });
                this.props.change("fileNames", []);
            }
        }
    }

    handleSetSelectedFile = (fileNames, files) => {
        console.log("fileNames:", fileNames.split(","))
        console.log("files:", files)

        this.setState({
            fileNames: fileNames.split(","),
            files: files.map(file => Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    }))
        });
        this.props.change("fileNames", fileNames);

        // 결과 미리보기 부분 숨기기
        const previewTagId = 'result-preview';
        var resultImage = document.getElementById(previewTagId);
        if( resultImage && !resultImage.parentElement.classList.contains("hidden") ) {
            resultImage.parentElement.classList.add("hidden");
        }
    };

    // 리렌더링이 불필요한 케이스 정의 
    shouldComponentUpdate(nextProps, nextState){
        if (
            nextProps.result === this.props.result &&
            nextProps.submitting === this.props.submitting &&
            nextProps.valid === this.props.valid &&
            nextProps.submitErrors === this.props.submitErrors &&
            this.state === nextState
        ) {
            console.log("DocumentFileDeIdentification >> shouldComponentUpdate : false");
            return false;
        }
        console.log("DocumentFileDeIdentification >> shouldComponentUpdate : true");
        return true;
    }

    // 저장버튼 클릭
    onSubmit = () => {
        console.log("onSubmit")

        const file = this.state.files[0];
        const fileName = this.state.fileNames[0];
        if( !file ) {
            throw new SubmissionError( {fileNames: <FormattedMessage id="common.file.empty" />} );
        }
        console.log("onSubmit OK")
        let formData = this._makeParams(file);
        const options = { method: 'post', multipart: true, data: formData};
        const downloadUrl = BACKEND_API_URL + FETCH_API[(this.props.menu+"_CREATE").toUpperCase()];

        this.setState({ isProcessing: true });
        const previewTagId = 'result-preview';
        download(downloadUrl, options, fileName, previewTagId)
            .catch((error) => {
                console.error('download - Error :', error.message);
                this.props.dispatchShowNotification(
                    <FormattedMessage id="common.download.failure"/>,
                    'warning'
                );
                return;
            })
            .finally(() => {
                this.setState({ isProcessing: false });
            });
    };

    _makeParams(file) {
        const { featureValue, languages } = this.props.formValues;

        let formData = new FormData();
        formData.append("file", file);
        formData.append("blobResponse", true);
        if( featureValue )
            formData.append("featureValue", featureValue);
        if( languages )
            formData.append("languages", languages);
        return formData;
    }

    displayLanguages( selected ) {
        return selected.map((value, idx) => (
            <FormattedMessage id={`document.image.languages.${value}`} >
                { txt => txt+(selected.length !== idx+1 ? ", " : "") }
            </FormattedMessage>
        ));
    }

    handlePreviewImageLoaded( evt ) {
        URL.revokeObjectURL(evt.target.src);
    }

    render() {
        const { fileNames, files, isProcessing } = this.state;
        const { 
            classes, color, result,
            submitting, valid, handleSubmit, submitErrors
        } = this.props;
        const errorMsg = submitErrors["fileNames"];

        return (
            <form autoComplete="off" onSubmit={handleSubmit(this.onSubmit)} noValidate>
                {/* 파일 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }} required>
                            <FormattedMessage id="document.image.deIdentification.file" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12}>
                            <ButtonFileUploaderComponent
                                multiple={false}
                                maxSize={5}
                                accept={[".png", ".bmp", ".gif", ".jpg", ".jpeg"]}
                                setSelectedFile={this.handleSetSelectedFile}
                                fileNames={fileNames.join()}
                            />
                            { errorMsg && <FormHelperText className={classes.labelRootError}>
                                {errorMsg}
                            </FormHelperText> }
                        </GridItem>
                    </GridContainer>
                </section>
                { files.length > 0 && <section className="formSection">
                    <GridContainer justify={"center"} alignContent={"center"} alignItems={"center"} >
                        <GridItem md={12} lg={6}>
                            <figure className="noMargin">
                                <img key={files[0].name} 
                                    alt="preview Source" 
                                    src={files[0].preview}
                                    className="imgPreview"
                                    onLoad={this.handlePreviewImageLoaded}
                                />
                                <figcaption className="figcaption">
                                    <FormattedMessage id="document.image.source" />
                                </figcaption>
                            </figure>
                        </GridItem>
                        <GridItem md={12} lg={6}>
                            <figure className="noMargin hidden">
                                <img id="result-preview"
                                    alt="preview Result"
                                    className="imgPreview"
                                />
                                <figcaption className="figcaption">
                                    <FormattedMessage id="document.image.result" />
                                </figcaption>
                            </figure>
                        </GridItem>
                    </GridContainer>
                </section> }
                {/* 이미지 파일 타입 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }}>
                            <FormattedMessage id="document.image.feature.type" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12} sm={6} lg={4}>
                            <FormField
                                name="featureValue"
                                component={CustomSelect}
                                color={color}
                                labelId="document.image.feature.type"
                                formControlProps={{ fullWidth: true }}
                                selectOptions={IMAGE_FEATURE_TYPES}
                                row
                            />
                        </GridItem>
                    </GridContainer>
                </section>

                {/* 언어정보 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }}>
                            <FormattedMessage id="document.image.languages" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12} sm={6} lg={4}>
                            <FormField
                                name="languages"
                                component={CustomSelect}
                                color={color}
                                labelId="document.image.languages"
                                formControlProps={{ fullWidth: true }}
                                selectOptions={IMAGE_LANGUAGES}
                                row
                                multiple={true}
                                inputProps={{ renderValue: this.displayLanguages }}
                            />
                        </GridItem>
                    </GridContainer>
                </section>

                <GridContainer 
                    justify={"center"}
                    alignItems={"center"}>
                    <GridItem>
                        <Button
                            color={color}
                            onClick={this.onSubmit}
                            disabled={submitting || files.length === 0 || !valid || isProcessing}
                        >
                            <FormattedMessage id="document.image.deIdentification.upload" />
                            {isProcessing && <CircularProgress size={24} color="inherit" />}
                        </Button>
                    </GridItem>
                </GridContainer>

                { !isEmpty(result) && 
                    <Fragment>
                        <section>
                            <ReactJson src={result} theme="monokai" />
                        </section>
                    </Fragment>
                }
                <input type="submit" style={{ display: "none" }}/>
            </form>

        );
    }
}

export default compose(
    withStyles(customCheckboxRadioSwitch),
    connect(
        ( state, props ) => ({
            result: state.main.item,
            refreshVersion: state.main.refreshVersion,
            formValues: getFormValues(props.form)(state),
            initialValues: getFormInitValues(state, DEFAULT_VALUES_FOR_IMAGE_DEIDENTIFICATION ),
            submitErrors: getFormSubmitErrors(props.form)(state)
        }), {
            dispatchCrudCreate: crudCreateForMultipartAction,
            dispatchShowNotification: showNotificationAction
        }
    ),
    reduxForm({
        //enableReinitialize: true
    })
)(ImageFileDeIdentification);
